import Icon from "assets/icons";
import { HelpCenter, Tutorials, FAQ, QueriesFeedBack, FeatureRequest, ContactSupport } from "components/help-support";
import { SidePanelTabs } from "components/shared";
import { ITabs, Tabs } from "components/tabs";
import Tab from "interfaces/Tab";
import { AppPage } from "layouts/types";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";





interface ScreenFeature {
    winWidth: number;
    winHeight?: number;
}

const Help: AppPage = () => {
    const router = useNavigate();
    const [activeTab, setActiveTab] = useState("help-center");

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const [screenWidth, setScreenWidth] = useState<ScreenFeature>({
        winWidth: 0,
        winHeight: 0,
    });

    const windowSize = () => {
        setScreenWidth({
            winWidth: window.innerWidth,
            winHeight: window.innerHeight,
        });
    };

    useEffect(() => {
        windowSize();
        window.addEventListener("resize", windowSize);

        return () => {
            window.removeEventListener("resize", windowSize);
        };
    }, []);

    const query = useQuery();

    useEffect(() => {
        const tab = query.get("tab");
        if (tab) {
            setActiveTab(tab);
        }
    }, [query]);

    const tabData: ITabs = {
        "Help Center": [
            {
                id: 1,
                TabContent: <HelpCenter setActive={handleTabClick} />,
            },
        ],
        "Viliyo Tutorials": [
            {
                id: 2,
                TabContent: <Tutorials />,
            },
        ],
        "FAQs": [
            {
                id: 3,
                TabContent: <FAQ />,
            },
        ],
        "Queries & Feedback": [
            {
                id: 4,
                TabContent: <QueriesFeedBack />,
            },
        ],
        "Feature Request": [
            {
                id: 5,
                TabContent: <FeatureRequest />,
            },
        ],
        "Contact Support": [
            {
                id: 6,
                TabContent: <ContactSupport />,
            },
        ],
    };

    const sidebarData: Tab[] = [
        {
            id: "help-center",
            label: "Help Center",
            icon: <img src={Icon.helpCenter} alt="helpCenter" width={15} height={15} />,
            content: <HelpCenter setActive={handleTabClick} />,
        },
        {
            id: "viliyo-tutorials",
            label: "Viliyo Tutorials",
            icon: <img src={Icon.vtIcon} alt="Tutorials" width={30} height={30} />,
            content: <Tutorials />,
        },
        {
            id: "faq",
            label: "FAQs",
            icon: <img src={Icon.faqIcon} alt="FAQ" width={30} height={30} />, //faqIcon
            content: <FAQ />,
        },
        {
            id: "queries-feedback",
            label: "Queries & Feedback",
            icon: <img src={Icon.QnFeedbackIcon} alt="queries" width={25} height={25} />, //queriesIcon
            content: <QueriesFeedBack />,
        },
        {
            id: "feature-request",
            label: "Feature Request",
            icon: <img src={Icon.FRequestIcon} alt="Feature" width={30} height={30} />,
            content: <FeatureRequest />,
        },
        {
            id: "contact-support",
            label: "Contact Support",
            icon: <img src={Icon.ContSupportIcon} alt="Contact" width={30} height={30} />,
            content: <ContactSupport />,
        },
    ];

    return (
        <div className="w-full">
            {screenWidth.winWidth < 768 ? (
                <Tabs data={tabData} />
            ) : (
                <SidePanelTabs
                    handleTabClick={handleTabClick}
                    activeTab={activeTab}
                    tabs={sidebarData}
                    title="Help & Support"

                />
            )}
        </div>
    );
};

export default Help;